/*   */
import React, { useContext, useEffect, useState } from "react";
import UserProfile from "../../../../app/partials/layout/UserProfile";
import { toAbsoluteUrl } from "../../../utils/utils";
import { connect } from "react-redux";
import * as builder from "../../../ducks/builder";
import { withRouter } from "react-router-dom";
import { Link } from "react-router-dom";
import HMenuItem from "./HMenuItem";
import LanguageSelectorDropdown from "../../../../app/partials/layout/LanguageSelector";
import QuickPanelToggler from "./quick-panel-toggler/QuickPanelToggle";
import VideocamIcon from "@mui/icons-material/Videocam";
import IconButton from "@mui/material/IconButton";
import Tooltip from "@mui/material/Tooltip";
import { FormattedMessage, injectIntl } from "react-intl";
import firebase from "firebase/app";
import "firebase/auth";
import { AuthContext } from "../../../../AuthContextProvider";

const Topbar = ({
  ktMenuClasses,
  ulClasses,
  rootArrowEnabled,
  isTutorConnectedToMeeting,
  meetingID,
  menuConfig,
  walletSidebar,
  setter,
  location,
  usdBalance,
  history,
}) => {
  const [currentUrl, setCurrentUrl] = useState(null);
  const { userContextApi } = useContext(AuthContext);
  const logOut = () => {
    firebase
      .auth()
      .signOut()
      .then(() => {
        localStorage.removeItem("auth");
        history.push("/");
      })
      .catch((error) => console.log(error));
  };

  useEffect(() => {
    setCurrentUrl(location.pathname.split(/[?#]/)[0]);
  }, []);

  return (
    <>
      <div style={{ display: "flex" }}>
        <div className="hidden kt-menu-wrapper" id="kt_header_menu_wrapper">
          <div
            id="kt_header_menu"
            className={`kt-header-menu kt-header-menu-mobile ${ktMenuClasses}`}
          >
            {isTutorConnectedToMeeting && (
              <Tooltip
                title="Back to meeting page"
                onClick={() => history.push("/meeting/" + meetingID)}
              >
                <IconButton aria-label="video" color="primary">
                  <VideocamIcon style={{ color: "#ffffff" }} />{" "}
                </IconButton>
              </Tooltip>
            )}

            <ul className={`kt-menu__nav ${ulClasses}`}>
              {menuConfig.header.items &&
                menuConfig.header.items.map((item, index) => {
                  return (
                    <React.Fragment key={`hmenuList${index}`}>
                      {item.title && currentUrl && (
                        // <div className="p-2 text-white">SAmet</div>
                        <HMenuItem
                          item={item}
                          currentUrl={currentUrl}
                          rootArrowEnabled={rootArrowEnabled}
                          history={history}
                        />
                      )}
                    </React.Fragment>
                  );
                })}
            </ul>
            <LanguageSelectorDropdown />
          </div>
        </div>
        {userContextApi.userData ? (
          <div className="kt-header__topbar">
            <QuickPanelToggler walletSidebar={walletSidebar} setter={setter} />
            {/* //menu */}
            <UserProfile
              logOutTrigger={() => logOut()}
              showAvatar={false}
              showHi={true}
              showBadge={true}
              usdBalance={usdBalance}
            />
          </div>
        ) : (
          <div className="kt-header__topbar">
            <Link className="flex justify-center items-center" to="/auth/login">
              <button className="rounded py-2 px-3 text-xs text-indigo-500 font-semibold uppercase">
                <FormattedMessage id="TOPBAR.LOGIN" defaultMessage="Login" />
              </button>
            </Link>

            <Link
              className="flex justify-center items-center text-sm"
              to="/auth/registration"
            >
              <button className="rounded py-2 px-3 text-xs text-indigo-500 font-semibold uppercase">
                <FormattedMessage
                  id="TOPBAR.REGISTER"
                  defaultMessage="Register"
                />
              </button>
            </Link>
          </div>
        )}
      </div>
    </>
  );
};

const mapStateToProps = (store) => ({
  config: store.builder.layoutConfig,
  menuConfig: store.builder.menuConfig,
  ktMenuClasses: builder.selectors.getClasses(store, {
    path: "header_menu",
    toString: true,
  }),
  rootArrowEnabled: builder.selectors.getConfig(
    store,
    "header.menu.self.root-arrow"
  ),
  headerSelfSkin: builder.selectors.getConfig(store, "header.self.skin"),
  ulClasses: builder.selectors.getClasses(store, {
    path: "header_menu_nav",
    toString: true,
  }),
  isTutorConnectedToMeeting: store.auth.isTutorConnectedToMeeting,
  meetingID: store.auth.meetingID,
});

export default injectIntl(connect(mapStateToProps)(withRouter(Topbar)));
